import { API_ENDPOINTS } from "../api-endpoints";
import { HttpClient } from "../http-client";
import {
  challengeByIdInterface,
  challengesDataInterface,
  ChallengesInterface,
  UserChallengesInterface,
} from "../types/types";

export const challenges = {
  createChallenges: (body: ChallengesInterface) => {
    return HttpClient.post<ChallengesInterface>(API_ENDPOINTS.CHALLENGES, body);
  },

  GetChallengesData: (options?: any) => {
    return HttpClient.get<challengesDataInterface>(
      API_ENDPOINTS.CHALLENGES,
      options
    );
  },
  GetUserChallengesData: (options?: any) => {
    return HttpClient.get<UserChallengesInterface>(
      API_ENDPOINTS.USER_CHALLENGES,
      options
    );
  },
  GetChallengeById: (id?: number) => {
    return HttpClient.get<challengeByIdInterface>(
      `${API_ENDPOINTS.CHALLENGES}/${id}`
    );
  },
  UpdateChallenge: (body: ChallengesInterface, id: number) => {
    return HttpClient.put<ChallengesInterface>(
      `${API_ENDPOINTS.CHALLENGES}/${id}`,
      body
    );
  },
  deleteChallenge: (id: number) => {
    return HttpClient.delete(`${API_ENDPOINTS.CHALLENGES}/${id}`);
  },
};
